import React, { useContext } from 'react';
import { format } from "date-fns";
import { dateForDateInputFromState, DateFormat, ensureDateStringHasTime } from "../../../../Helpers/DateTimeHelper";
import FormRow from "../../../HorizontalForm/FormRow";
import AmenitySelector from "../../../../Modules/Bookings/Components/AmenitySelector";
import AmenityAvailability from "../../../../Modules/Bookings/Forms/Inputs/AmenityAvailability";
import { ReschedulerFormContext, useReschedulerForm } from "./ReschedulerFormProvider";
import { intervalFromState } from "../../../../Helpers/IntervalHelper";
import TextField from "@mui/material/TextField";
import BookingConfigProvider from "../../../../Modules/Bookings/Forms/BookingConfigProvider";

const ReschedulerForm = (props) => {

    const {
        mainBookingConfig,
        localBookingConfig,
        occurrence,

        rescheduledAmenity,
        rescheduledAmenityId,
        rescheduledDate,
        rescheduledInterval,

        onAmenityIdChange,
        onDateChange,
        onBoundaryChange,
        onRescheduledIntervalChange,
        onConfirm
    } = useReschedulerForm();

    const occurrenceInterval = intervalFromState(occurrence);

    const handleRescheduledTimeChange = (newInterval) => {
        onRescheduledIntervalChange({
            start: newInterval?.start ?? null,
            end: newInterval?.end ?? null,
        });
    }

    const handleRescheduledBookingDateChange = (newDate) => {
        onDateChange(newDate)
    }

    return (
        <div style={{ margin: '0 0.2rem' }}>
            <p className="margin-bottom-2">
                Find an alternate booking for {format(occurrenceInterval.start, DateFormat.HUMAN_SLASHED_DATE)}&nbsp;
                at {format(occurrenceInterval.start, DateFormat.MYSQL_TIME)}-{format(occurrenceInterval.end, DateFormat.MYSQL_TIME)}&nbsp;
            </p>
            <form>
                <FormRow label="Amenity">
                    <AmenitySelector
                        forBookingConfig={localBookingConfig} value={rescheduledAmenityId}
                        onChange={(name, value) => onAmenityIdChange(value)}
                        onlyRecurringAmenities
                    />
                </FormRow>

                <FormRow label="Date" required={true}>
                    <TextField
                        type="date"
                        name="date"
                        value={dateForDateInputFromState(rescheduledDate)}
                        onChange={(event) => onDateChange(event.target.value)}
                        style={{ width: 140 }}
                    />
                </FormRow>

                <FormRow label="Time" required={true}>
                    {(!!localBookingConfig && !!rescheduledAmenity) && (
                        <BookingConfigProvider
                            unitId={mainBookingConfig.unit_id ?? null}
                            bookingDate={ensureDateStringHasTime(rescheduledDate)}
                            amenity={rescheduledAmenity}
                            bookingConfig={localBookingConfig}
                        >
                            <AmenityAvailability
                                isEditingExistingBooking={false} showBookButton={false}
                                showNextAvailabilityButton={false}

                                selectedInterval={
                                    (!rescheduledInterval.start && localBookingConfig.is_variable)
                                        ? occurrence
                                        : rescheduledInterval
                                }
                                onChange={handleRescheduledTimeChange}
                            />
                        </BookingConfigProvider>
                    )}
                </FormRow>
            </form>
        </div>
    );
};

ReschedulerForm.propTypes = {};

ReschedulerForm.defaultProps = {};

export default ReschedulerForm;
